module.exports = __webpack_public_path__ + "img/template_3.7f5135c6.jpg";